<lex-sidenav-container>
  <ng-container left>
    <div></div>
        <!--Custodian Main Layout left nav Add and Search-->
        <div style="margin-top: 8px; font-size: 15px; height: 75px; align-items: center">
          <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column; place-content: stretch space-between; align-items: stretch; gap: 20px;">
            <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row">
              <div mat-line style="width:100%; display: flex;">
                <button mat-mini-fab color="primary" class="add-custodian-button" *ngIf="showEdit" (click)="onAddCustodian()" matTooltip="Create new custodian">
                  <mat-icon>add</mat-icon>
                </button>
                <mat-form-field style="margin-left:15px; margin-right: 15px; width:100%">
                  <input matInput placeholder="Search Custodians" #searchBox id="search-box" (keyup)="onUpdateSearchText(searchBox.value)" />
                  <button mat-button *ngIf="searchBox.value" matSuffix aria-label="Clear" (click)="searchBox.value=''; onUpdateSearchText(searchBox.value)">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <cdk-virtual-scroll-viewport #leftScroll itemSize="48" style="height:87%">
          <mat-action-list>
            <!--Custodian Main Layout left nav list-->
            <button mat-list-item *cdkVirtualFor="let custodian of custodians" [ngClass]="{'sidenav-selected-item': selectedCustodian === custodian, 'sidenav-row-item': selectedCustodian !== custodian}" (click)="selectedCustodian = custodian" (mouseover)="hoverFieldId=custodian.custodianId" (mouseout)="hoverFieldId=null">
              <div matListItemIcon>
                <mat-icon *ngIf="!custodian.isOrganization" class="sidenav-icon-avatar">face</mat-icon>
                <mat-icon *ngIf="custodian.isOrganization" class="sidenav-icon-avatar">store_mall_directory</mat-icon>
              </div>
              <div matListItemTitle> {{custodian.name}} </div>
              <div matListItemLine style="color:grey"> {{custodian.affiliation}} </div>
              <div style="min-width: 40px; margin: auto 0;" *ngIf="showEdit" matListItemMeta>
                <button mat-icon-button matTooltip="Delete" [style.visibility]="custodian.custodianId !== hoverFieldId ? 'hidden': 'visible'" (click)="onDeleteCustodian(custodian.custodianId)" style="pointer-events: auto;">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
              <div>
              </div>
              <mat-divider></mat-divider>
            </button>
          </mat-action-list>
        </cdk-virtual-scroll-viewport>
  </ng-container>

  <!--Custodian Main Layout main content-->
  <ng-container right>
    <div style="flex-direction: column; box-sizing: border-box; display: flex; place-content: stretch space-between; align-items: stretch; flex: 1 1 0%; gap: 20px;">
      <div></div>
      <div style="flex-direction: row; box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px;">
        <div></div>
        <lex-custodian-details style="flex: 1 1 0%; box-sizing: border-box;" [custodian]="selectedCustodian" [canEdit]="showEdit" [showSelect]="showSelect" (updateCustodiansEvent)="updateCustodianList($event)"></lex-custodian-details>
        <div></div>
      </div>
      <div></div>
    </div>
  </ng-container>
</lex-sidenav-container>
